var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtGeneratorCopyPrompt = function SvgIconArtGeneratorCopyPrompt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7c0-1.542 0-2.314.483-2.793s1.262-.48 2.817-.48H9.2c1.555 0 2.334 0 2.817.48.483.479.483 1.25.483 2.793v2.728c0 1.542 0 2.314-.483 2.793S10.755 13 9.2 13H7.55c-1.555 0-2.334 0-2.817-.48s-.483-1.25-.483-2.793z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15 10.273c-.438 0-.857-.173-1.167-.48A1.63 1.63 0 0 1 1.5 8.636V5.364c0-2.057 0-3.086.645-3.725C2.789 1.001 3.826 1 5.9 1h2.2c.438 0 .857.172 1.167.48.31.306.483.722.483 1.156"
  }))));
};
export default SvgIconArtGeneratorCopyPrompt;